// BaseLayoutContext.js
import React, { createContext, useState } from 'react';

export const BaseLayoutContext = createContext({
  triggerLoginModuleToggleValue: false,
  setTriggerLoginModuleToggleValue: () => {},
  signOrSignUp: true,
  chooseSignUp_SignIn: () => {},
  TriggerLoginModuleBtn: () => {},
  TriggerLoginModuleBtnFromModule: () => {},
});

const BaseLayoutProvider = ({ children }) => {
  const [triggerLoginModuleToggleValue, setTriggerLoginModuleToggleValue] = useState(false);
  const [signOrSignUp, setSignOrSignUp] = useState(true);

  const TriggerLoginModuleBtn = () => {
    setTriggerLoginModuleToggleValue(true);
  };

  const TriggerLoginModuleBtnFromModule = () => {
    setTriggerLoginModuleToggleValue(false);
  };

  const chooseSignUp_SignIn = (bool) => {
    setSignOrSignUp(bool);
  };

  const contextValue = {
    triggerLoginModuleToggleValue,
    setTriggerLoginModuleToggleValue,
    signOrSignUp,
    chooseSignUp_SignIn,
    TriggerLoginModuleBtn,
    TriggerLoginModuleBtnFromModule,
  };

  return (
    <BaseLayoutContext.Provider value={contextValue}>
      {children}
    </BaseLayoutContext.Provider>
  );
};

export default BaseLayoutProvider;
